export default "__VITE_ASSET__c6b4c4ed__"